<div class="lg:mt-16 max-w-[450px] mx-auto p-8 bg-card rounded-lg ">
  <ng-content/>
</div>
